export const LOADING_CARD_COUNT = 12;

export const DEFAULT_TAGS_MODE = "and";
export const DEFAULT_BROWSE_LIMIT = 12;
export const DEFAULT_BROWSE_INCLUDE_COUNT = true;
export const DEFAULT_BROWSE_PAGE = 1;

// Keyword search: URL `q` → API `title` (case-insensitive substring on article title)
export const MAX_SEARCH_QUERY_LENGTH = 100;
export const SEARCH_DEBOUNCE_MS = 400;

// Mobile browse layout: the sticky toolbar + filter sheet replace the stacked filter
// block below this width. Kept in step by hand with the `max-width: 639px` / 640px
// breakpoints in Browse.module.scss, article-card.scss and tag-list.scss.
export const BROWSE_MOBILE_MEDIA_QUERY = "(max-width: 639px)";

// Tag pills shown on a collapsed mobile article card. Seven pills plus a "+5 more" was a
// large share of the card's height; the rest stay one tap away behind the count.
export const MOBILE_CARD_TAG_LIMIT = 2;

// Grid columns by viewport, widest first. Keep in step with Browse.module.scss.
export const BROWSE_GRID_COLUMNS = [
  ["(min-width: 1440px)", 4],
  ["(min-width: 1024px)", 3],
  ["(min-width: 640px)", 2],
];

export const BROWSE_QUERY_KEY = "browseArticles";
export const BROWSE_COUNT_QUERY_KEY = "browseArticleCount";
export const BROWSE_TAGS_QUERY_KEY = "browseArticleTags";
export const BROWSE_RECOMMENDED_TAGS_QUERY_KEY = "browseRecommendedArticleTags";
